// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/5e175dc04e9d0ed4ff4e.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5218f1208de7eb1f1afc","114":"8f2ea0adb4a3a1dc686e","115":"0683372dbf8d1111a117"}[chunkId] + ".chunk.js";
};